const LOG_PREFIX = "[OCM][Custom] "
const Aniview = require('../../services/aniview')

let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    utils.contentLoaded().then(() => {
      runOutstream(utils)

      var selector = document.querySelectorAll("#thecontent p")[3]
      if (!selector) {
        selector = document.querySelectorAll("#thecontent p")
        selector = selector[selector.length-1]
      }

      ocmPassback(utils, selector)
    })

    resolve(true)
  });
};

let runOutstream = (utils) => {
  if (utils.config.debug) {
    console.log(LOG_PREFIX + 'Running outstream')
  }

  (function (w, d, s) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }

    if (w.teads !== undefined) {
      return;
    }

    let exclude_urls = [
      //{'url': '2935139'}
    ]

    for (var z = 0; z < exclude_urls.length; z++) {
      if (w.location.href.indexOf(exclude_urls[z].url) > -1) {
        return;
      }
    }

    var selector = document.querySelectorAll("#thecontent p")[0];
    if (!selector) {
      return
    }

    var ttag = function () {
      w.teads.page(77249).placement(95790, {
        slider: {allow_corner_position: false, allow_top_position: false},
        "css": "width:100% !important; height:auto !important; margin: 0px auto 26px",
        "format": "inread",
        "slot": {"insertAfter": true, "btf": false, "selector": selector, "minimum": 0}
      }).passback(function () {
              
        window.top.OCM.oipb = () => {          
          if (window.location.href.indexOf('troxaio-me-anatropi-oximatos-stin-kifisias-xoris-traymatismous-alla-prokalese-mpotiliarisma') >= -1) {
            vidverto()
          } else {
            initMox(utils)
          }
      	}
        
        utils.config.services.aniview.active = true
		const av = new Aniview(utils, utils.config)
		av.run()
        
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var protocol = w.location.protocol.match(/^https?:$/) ? w.location.protocol : 'https:';
      s.src = protocol + '//a.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    }
  })(window, document, document.createElement('script'));
}

let ocmPassback = (utils, selector) => {
  if (!selector) {
    return
  }

  window.googletag.cmd.push(() => {
    let inread = googletag.sizeMapping()
    .addSize([0,0], [[1,1], [300,250]])
    .addSize([360,0], [[1, 1], [300,250],[336,280]])
    .build()

    googletag.defineSlot('/1026856/flash.gr/inread_pb', [[1, 1], [300, 250], [336, 280]], 'ocm-outstream').defineSizeMapping(inread).addService(googletag.pubads());

    selector.insertAdjacentHTML('afterend', `<div id="ocm-outstream" style="margin-bottom:1.55em"></div>`)
    let div = document.getElementById('ocm-outstream')
    let script = document.createElement('script')
    script.text = `googletag.cmd.push(() => { googletag.display('ocm-outstream'); })`
    div.append(script)
  })
}

let initMox = (utils) => {
  if (utils.config.debug) {
    console.log(LOG_PREFIX + 'Running MOX')
  }

  let selector = document.querySelectorAll("#thecontent p")[0]
  selector.insertAdjacentHTML('afterend', `<div data-id='_mwayss-2355d53d847d4b7e2ab453b0fdcbb83c'></div>`)

  ;(function(window, document, undefined) {
    var script_tag = document.createElement('script');
    script_tag.src = 'https://ad.mox.tv/mox/mwayss_invocation.min.js?pzoneid=7144&height=405&width=720&tld=flash.gr&ctype=div';
    var container = document.querySelectorAll('[data-id=_mwayss-2355d53d847d4b7e2ab453b0fdcbb83c]')[0];    
    container.setAttribute('id', (container.getAttribute('data-id')+(new Date()).getTime()));
    container.removeAttribute('data-id');
    container.parentNode.insertBefore(script_tag, container);
  })(window, document);
}

const vidverto = () => {
  console.log('vidverto')
  let selector = document.querySelectorAll("#thecontent p")[0]

  if (!selector) {
    return;
  }

  var script = document.createElement('script');

  script.setAttribute('id', '_vidverto-232c4f7dcbba74a82023299f15cf07f3');
  script.text = '  (function (v,t) {\n' +
    ' var a = t.createElement("script");\n' +
    ' a.src = "https://ad.vidverto.io/vidverto/js/aries/v1/invocation.js";\n' +
    ' a.setAttribute("fetchpriority","high");\n' +
    ' var r = v.top;\n' +
    ' r.document.head.appendChild(a);\n' +
    ' v.self!==v.top&&(v.frameElement.style.cssText="width:0px!important;height:0px!important;");\n' +
    ' r.aries = r.aries||{};\n' +
    ' r.aries.v1 = r.aries.v1||{commands:[]};\n' +
    ' var c = r.aries.v1;\n' +
    ' c.commands.push(\n' +
    '   (function(){\n' +
    '     var t = v.frameElement||"#_vidverto-232c4f7dcbba74a82023299f15cf07f3";\n' +
    '     c.mount("7144",t,{width:720,height:405})})\n' +
    ' )\n' +
    '})(window,document);'
  selector.append(script);
}

module.exports = customCode;